export const test = {
    PRE_SIGNED_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v2/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v2/operations?',
    GEMINI_PRE_SIGNED_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/presignedPost',
    GEMINI_NOTIFY_OPERATION_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/operationPost',
    GEMINI_FILEDOWNLOAD_OPERATION_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/files/',
    GEMINI_APP_BOM_IMPORT_URL: 'https://pdf-frontend-stage.alttest.pdf.nike.io/multi-import'
}
export const local = {
    PRE_SIGNED_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v2/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v2/operations?',
    GEMINI_PRE_SIGNED_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/presignedPost',
    GEMINI_NOTIFY_OPERATION_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/operationPost',
    GEMINI_FILEDOWNLOAD_OPERATION_URL: 'https://api.test.pdf.nike.io/core/v1/bomImport/files/',
    GEMINI_APP_BOM_IMPORT_URL: 'https://pdf-frontend-stage.alttest.pdf.nike.io/multi-import'
}
export const sandbox1 = {
    PRE_SIGNED_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/operations?'
}
export const sandbox = {
    PRE_SIGNED_URL: 'https://dataloader-api-sandbox.pes-sandbox.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-sandbox.pes-sandbox.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-sandbox.pes-sandbox.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-sandbox.pes-sandbox.nike.com/pcx/dla/v1/operations?'
}
export const dev = {
    PRE_SIGNED_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v2/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v2/operations?',
    GEMINI_PRE_SIGNED_URL: 'https://api.alttest.pdf.nike.io/core/v1/bomImport/presignedPost',
    GEMINI_NOTIFY_OPERATION_URL: 'https://api.alttest.pdf.nike.io/core/v1/bomImport/operationPost',
    GEMINI_FILEDOWNLOAD_OPERATION_URL: 'https://api.alttest.pdf.nike.io/core/v1/bomImport/files/',
    GEMINI_APP_BOM_IMPORT_URL: 'https://pdf-frontend-dev.test.pdf.nike.io/multi-import'
}
export const prod = {
    PRE_SIGNED_URL: 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v2/operations',
    FILEDOWNLOAD_OPERATION_URL : 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL:'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v2/operations?',
    GEMINI_PRE_SIGNED_URL: 'https://api.prod.pdf.nike.io/core/v1/bomImport/presignedPost',
    GEMINI_NOTIFY_OPERATION_URL: 'https://api.prod.pdf.nike.io/core/v1/bomImport/operationPost',
    GEMINI_FILEDOWNLOAD_OPERATION_URL: 'https://api.prod.pdf.nike.io/core/v1/bomImport/files/',
    GEMINI_APP_BOM_IMPORT_URL: 'https://gemini.nike.io/multi-import'
}